angular.module("app").controller("GamesListPageController", [
    '$scope',
    'pageStatuses',
    'pagination',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    '$state',
    'preloadedData',
    'preloadedCategories',
    'preloadedSubCategories',
    'logger',
    'preloadedProviders',
    function ($scope, pageStatuses, pagination, $timeout, casinoGameService, errorHandler, $state, preloadedData, preloadedCategories, preloadedSubCategories, logger, preloadedProviders) {
        var pendingListRequest;

        $scope.games = angular.copy(preloadedData.games);
        $scope.tabOptions = {};
        $scope.filterOptions = {
            status: pageStatuses[0]
        };
        $scope.pageStatuses = pageStatuses;
        $scope.multiSelect = {
            selectedCategories: [],
            selectedSubCategories: [],
            selectedProviders: [],
            categories: angular.copy(preloadedCategories),
            subCategories: angular.copy(preloadedSubCategories),
            providers: angular.copy(preloadedProviders)
        };

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData =  getFiltersValues();
                resetPage && (requestData.current_page = 1);
                updateList(requestData)
            }, 300);
        }, preloadedData.total_count);

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.editGame = function (game) {
            $state.go("main.games.edit", {gameId: game.id})
        };

        $scope.switchSkin = function (game) {
            $state.go("main.games.switchSkins", {gameId: game.id})
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {return $scope.pagination.changePage()};

        $scope.publishGame = function (game) {
            casinoGameService.publishGame(game.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(game);
                        logger.logSuccess("global.successfullyPublished");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        $scope.deleteGame = function (game) {
            casinoGameService.deleteGame(game.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(game);
                        logger.logSuccess("global.successfullyDeleted");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        function spliceFromList(game) {
            var index = $scope.games.indexOf(game);
            if (index != -1) {
                $scope.games.splice(index, 1);
            }
        }

        function updateList (requestOptions) {
            casinoGameService.get(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.games = angular.copy(response.games)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function getFiltersValues() {
            var categories = [],
                subCategories = [],
                providers = [];

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                categories.push(value.id)
            });

            $scope.multiSelect.selectedSubCategories.forEach(function (value) {
                subCategories.push(value.id)
            });

            $scope.multiSelect.selectedProviders.forEach(function (value) {
                providers.push(value.id)
            });

            return {
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                categories: categories,
                subCategories: subCategories,
                providers: providers
            }
        }
    }
]);